import * as React from 'react';
import { useSelector } from 'react-redux';

import { IApplicationState } from '../../types/redux';
import { ValuationFilters } from '../../components/ValuationFilters';
import { MainFiltersWidgetContainer } from '../MainFiltersWidgetContainer';
import { ValuationFiltersSubmitContainer } from '../ValuationFiltersSubmitContainer';
import { OpenDataPaymentFormContainer } from '../OpenDataPaymentFormContainer';
import { selectIsDataPaymentFeatureActive } from '../../selectors/featureToggles/selectIsDataPaymentFeatureActive';

export function ValuationFiltersContainer() {
  const subdomain = useSelector((state: IApplicationState) => state.subdomain);
  const isDataPaymentFeatureActive = useSelector(selectIsDataPaymentFeatureActive);

  return (
    <ValuationFilters
      subdomain={subdomain}
      mainFiltersWidget={<MainFiltersWidgetContainer />}
      valuationFiltersSubmit={
        isDataPaymentFeatureActive ? <OpenDataPaymentFormContainer /> : <ValuationFiltersSubmitContainer />
      }
    />
  );
}
